import { render } from "./limitedAvailabilityMessage.vue?vue&type=template&id=39c3ed34"
import script from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js"
export * from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__